import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { useTranslation } from 'react-i18next';
import { Route, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SelectCompanyFirstComponent from '../../components/SelectCompanyFirstComponent';
import { areFeatureTogglesFetched, getSelectedCompany } from '../../store/selectors';
import { Loader } from '../../components';
import MyProfile from './MyProfile';

const renderContent = (selectedCompany, match) => (
  !selectedCompany ? <SelectCompanyFirstComponent /> : (
    <>
      <Route
        exact
        path={`${match.url}`}
        component={MyProfile}
      />
    </>
  )
);

export default () => {
  const match = useRouteMatch();
  const selectedCompany = useSelector(getSelectedCompany);
  const featureTogglesFetched = useSelector(areFeatureTogglesFetched);
  const { t } = useTranslation();

  return (
    <>
      <BreadcrumbsItem to="/my-profile">
        {t('BREADCRUMB.MY_PROFILE')}
      </BreadcrumbsItem>
      {!featureTogglesFetched ? <Loader /> : renderContent(selectedCompany, match)}
    </>
  );
};
